export default {
  H2: 'h2',
  CH4: 'ch4',
  C2H6: 'c2h6',
  C2H4: 'c2h4',
  C2H2: 'c2h2',
  CO: 'co',
  CO2: 'co2',
  N2: 'n2',
  O2: 'o2',
  RATE_H2: 'TaxaH2',
  RATE_N2: 'TaxaN2',
  RATE_O2: 'TaxaO2',
  RATE_CO: 'TaxaCO',
  RATE_CO2: 'TaxaCO2',
  RATE_CH4: 'TaxaCH4',
  RATE_C2H6: 'TaxaC2H6',
  RATE_C2H4: 'TaxaC2H4',
  RATE_C2H2: 'TaxaC2H2',
};
